/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Rwamiko 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Cyeru": ["Bugarura", "Gabiro", "Kamurenzi", "Karika", "Mukuyu", "Murambi", "Nyagasozi", "Rugarama"],
  "Kigabiro": ["Cyiri", "Kabira", "Kanyove", "Karangara", "Mutambiko", "Rubuye"],
  "Nyagahinga": ["Kabusunzu", "Kibiraro", "Kigaga", "Ntaremba", "Rugarama"]
};